import MicroFrontendLocal from "./Microfrontend.local";
import MicroFrontendProd from "./Microfrontend.prod";

const Microfrontend =
  process.env.REACT_APP_ENV === "proxyprov"
    ? MicroFrontendLocal
    : MicroFrontendProd;

export default Microfrontend;
